.mainContainer {
  display: flex;
  flex-direction: row;
}
